import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { createKegTap, deleteKegTap, getTapBoard } from '../lib/api'

export const kegTapKeys = {
	all: ['keg-taps'] as const,
}

export const tapBoardQuery = () =>
	queryOptions({
		queryKey: kegTapKeys.all,
		queryFn: getTapBoard,
	})

export function useLogKegTap() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: createKegTap,
		onSettled: () => queryClient.invalidateQueries({ queryKey: kegTapKeys.all }),
	})
}

export function useRemoveKegTap() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: deleteKegTap,
		onSettled: () => queryClient.invalidateQueries({ queryKey: kegTapKeys.all }),
	})
}
